import { fillInTheBlanksBaseExtensionConfig } from '@lessonup/pins-shared';
import { cssBase, cx } from '@lessonup/ui-components';
import { generateHTML, NodeViewRendererProps, Node as TiptapNode } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import React, { useContext } from 'react';
import { FillInTheBlanksInteractionContext } from '../../contexts/fillInTheBlanks/FillInTheBlanksInteractionContext';
import { blankNodeCss, previewCss } from './FillInTheBlanksAreaPinComponent.utils';
import { fillInTheBlanksViewerExtensions } from './FillInTheBlanksTiptapViewer';
import { getBackgroundColor, getBorderStyle, getTextColor } from './utils/blankInteraction';

export const fillIntheBlanksPlayerExtension = TiptapNode.create({
  ...fillInTheBlanksBaseExtensionConfig,
  addNodeView: () => {
    return ReactNodeViewRenderer(FillInTheBlanksPlayerWordNode);
  },
});

export const FillInTheBlanksPlayerWordNode: React.FC<NodeViewRendererProps> = ({ getPos }) => {
  const {
    activeWord,
    handleClickBlank: handleClickWord,
    answers,
    isEditing,
    isAnswerCorrect,
    isResultsPhase,
  } = useContext(FillInTheBlanksInteractionContext);
  const pos = getPos();
  const isActive = pos === activeWord;

  const answer = answers[pos];
  const hasAnswer = answer !== undefined;
  const answerIsCorrect = hasAnswer ? isAnswerCorrect(answer.answerIndex) : false;
  const content = hasAnswer ? generateHTML(answer.content, fillInTheBlanksViewerExtensions) : '&nbsp;';

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (isEditing) {
      handleClickWord(pos);
    }
  };

  const backgroundColor = getBackgroundColor(isResultsPhase, isActive, isEditing, hasAnswer);

  return (
    <NodeViewWrapper
      key={`node-${pos}`}
      className={cx(blankNodeCss, !hasAnswer && previewCss, isEditing && clickableNodeCss)}
      onClick={handleClick}
      style={{
        backgroundColor,
        cursor: isEditing ? 'pointer' : 'default',
        border: getBorderStyle(isResultsPhase, isEditing, isActive),
        textDecoration: isResultsPhase && !answerIsCorrect ? 'underline' : undefined,
        color: getTextColor(isResultsPhase, isEditing, answerIsCorrect),
      }}
    >
      <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
    </NodeViewWrapper>
  );
};

// pointer-events: none are on by default becouse of the tiptap editor
const clickableNodeCss = cssBase`
  pointer-events: auto;
`;
